import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import AudioController from './AudioController.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        <Canvas
            flat
            camera={ {
                fov: 45,
                near: 0.1,  // Also fixed this - 10 is too large
                far: 500,
                position: [0, 5, -15]
            } }
        >
            <Experience />
        </Canvas>
        <AudioController />
    </>
)